import { FaCrown, FaUserPlus } from "react-icons/fa";
import { CopyIcon } from "../../icons";

const LeaderBoardCard = ({ stylist, referral }) => {
    const initials = stylist?.displayName
        ?.split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase();

    const referralinitials = `${referral?.firstName} ${referral?.lastName}`
        ?.split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase();

    const getStatusClasses = (status) => {
        switch (status) {
            case "LEAD":
                return "bg-amber-100 text-amber-600 dark:bg-amber-900 dark:text-amber-300";
            case "QUIZ_STARTED":
                return "bg-blue-100 text-blue-600 dark:bg-blue-900 dark:text-blue-300";
            case "COMPLETED":
                return "bg-green-100 text-green-600 dark:bg-green-900 dark:text-green-300";
            case "FAILED":
                return "bg-red-100 text-red-600 dark:bg-red-900 dark:text-red-300";
            default:
                return "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300";
        }
    };

    return (
        <>
            {stylist && (
                <div className="p-6 rounded-xl border bg-white dark:bg-gray-800 transition-all flex flex-col items-center text-center hover:ring-1 ring-orange-200">
                    <div className="w-20 h-20 mb-2 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center overflow-hidden bg-blend-multiply ">
                        {stylist?.imageUrl ? (
                            <img
                                src={stylist?.imageUrl}
                                alt={stylist?.displayName}
                                className="w-full h-full object-cover"
                            />
                        ) : (
                            <span className="text-lg font-bold text-gray-600 dark:text-gray-300">
                                {initials}
                            </span>

                        )}
                    </div>
                    <h2 className=" flex items-center gap-3 text-lg font-semibold text-gray-800 dark:text-white mb-1">
                        <FaCrown className={`w-5 h-5 text-yellow-500`} />
                        {stylist?.displayName}
                    </h2>
                    <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
                        @{stylist?.stylistName}
                    </p>
                    <div className="flex items-center justify-center gap-3">
                        <div className=" flex -space-x-4">
                            {Array.from({ length: Math.min(stylist?.matches || 0, 3) }).map((_, i) => (
                                <div
                                    key={i}
                                    className="w-8 h-8 rounded-full flex items-center justify-center bg-gradient-to-r from-amber-400 to-orange-500 text-white font-semibold text-xs border-2 border-white dark:border-gray-800"
                                >
                                    <FaUserPlus />
                                    {/* {i + 1} */}
                                </div>
                            ))}

                            {/* Show "+N" if more than 3 matches */}
                            {stylist?.matches > 3 && (
                                <div className="w-8 h-8 rounded-full flex items-center justify-center bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-200 text-xs font-medium border-2 border-white dark:border-gray-800">
                                    +{stylist?.matches - 3}
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            )}
            {referral && (

                <div className="p-6 rounded-xl border bg-white dark:bg-gray-800 transition-all flex flex-col items-center text-center hover:ring-1 ring-orange-200">
                    <div className="w-20 h-20 mb-2 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center overflow-hidden bg-blend-multiply ">
                        {referral?.imageUrl ? (
                            <img
                                src={referral?.imageUrl}
                                alt={referral?.displayName}
                                className="w-full h-full object-cover"
                            />
                        ) : (
                            <span className="text-lg font-bold text-gray-600 dark:text-gray-300">
                                {referralinitials}
                            </span>

                        )}
                    </div>
                    <h2 className=" flex items-center gap-3 text-lg font-semibold text-gray-800 dark:text-white mb-1">
                        <FaUserPlus className={`w-5 h-5 text-[#CA8A04]`} />
                        {`${referral?.firstName} ${referral?.lastName}`}
                    </h2>

                    <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">

                        {referral?.email}
                    </p>
                    <p className="flex justify-center items-center text-sm text-gray-500 dark:text-gray-400 mb-3">
                        <CopyIcon
                            className={"size-4 transition-colors"}
                        />
                        {referral?.refCode}
                    </p>


                    <span
                        className={`px-3 py-1 text-xs font-medium rounded-full ${getStatusClasses(
                            referral?.status
                        )}`}
                    >
                        {referral.status === "QUIZ_STARTED"
                            ? "STATED"
                            : referral.status === "STARTED"
                                ? "Started"
                                : referral.status}
                    </span>
                </div>
            )}
        </>
    );

};

export default LeaderBoardCard;
